
































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { ProposalState } from '@/enums/ProposalState';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
@Component
export default class PendingProposalEvaluationsTableComponent extends GenericBTable<Annoucement> {

  @Prop() public tipoEvaluacion!: number; 

  get user() {
    return this.$store.state.user;
  }

  created() {
    this.tableConfig.controller = `Porposal/getProposalByUser/${this.user.id}/AndEvaluationState/${this.tipoEvaluacion}`;
    this.formatColumns();
  }

  formatColumns() {
      let name = new BTableColumn("name", "table.proposal", true);
      name.customTemplate = true;
      let sendDateToIES = new BTableColumn(
        "sendDateToIES",
        "table.sendDate",
        true
      );
      sendDateToIES.type = BTableColumnType.DateTime;
      this.tableConfig.insertColumns(name, sendDateToIES);
      this.tableConfig.actions.customTemplate = true;
      this.tableConfig.enableDefaultColumns = false;
  }

  public verOpciones(row: Annoucement) {
    this.$router.push(`/convocatoria/propuesta/${row.id}/evaluation/${this.tipoEvaluacion}`);
  }
}
